import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SmluvniCenaND = {
	name: NAME,
	apiProvider,
	router,
};
